module.exports = __webpack_public_path__ + "f1c5e0f8a0af75d8ccee09d3193a8e22.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/airbnb_2022_chart.png
// module id = 1626
// module chunks = 0